import { REACT_APP_MAIN_SITE_HOMEPAGE } from 'config';
import { api } from '../api';
import { SupportedLanguageCode } from 'i18n/i18n.types';
import { sayError } from 'utils/functions/say';
import { TCmsContentStructureResponse } from './cmsContent.types';
import CmsContentEndpoints from './cms.endpoints';

const enhancedApi = api.injectEndpoints({
  endpoints: (build) => ({
    CmsContentStructure: build.query<
      TCmsContentStructureResponse,
      SupportedLanguageCode
    >({
      async queryFn() {
        try {
          const url = `${REACT_APP_MAIN_SITE_HOMEPAGE}/${CmsContentEndpoints.getBanners}`;
          const response = await fetch(url);
          const parsedResponse = await response.json();
          return { data: parsedResponse };
        } catch (error) {
          sayError('CmsContentStructure error: ', error);

          return {
            error: {
              status: 422,
              data: null,
              error: 'Error fetching header structure',
            },
          };
        }
      },
    }),
  }),
});

export const { useCmsContentStructureQuery } = enhancedApi;
